// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1OiAy","wave":"styles_wave__MOvcQ"};